import { RefObject } from 'react';
import { HierarchyPointNode } from 'd3-hierarchy';
import { HierarchyData, MilestoneData, NodeData } from './model';

export function getClientSize(containerRef: RefObject<HTMLDivElement>) {
  const width = containerRef.current?.getBoundingClientRect().width || 0;
  const height = containerRef.current?.getBoundingClientRect().height || 0;
  return { width, height };
}

export function calculateCanvasSize<DT extends HierarchyData>(
  root: HierarchyPointNode<DT>,
  lastNodeWidth: number,
  lastNodeHeight: number,
) {
  let canvasWidth = Number.MIN_VALUE;
  let canvasHeight = Number.MIN_VALUE;

  root.each((node: HierarchyPointNode<DT>) => {
    canvasWidth = Math.max(canvasWidth, node.x);
    canvasHeight = Math.max(canvasHeight, node.y);
  });

  canvasWidth += lastNodeWidth; // add the width of the last node
  canvasHeight += lastNodeHeight; // add the height of the last node

  return { canvasWidth, canvasHeight };
}

export function populateParentId(milestones: MilestoneData[]): NodeData[] {
  return milestones.map((milestone, index) => {
    return {
      ...milestone,
      parentId: milestones[index - 1]?.id,
    };
  });
}
